import { useLocation } from 'react-router-dom';

import { TooltipProvider } from '@/components/ui/tooltip';
import AppSidebar from '@/components/layout/AppSidebar';
import BrandBar from '@/components/layout/BrandBar';
import LanguageSwitcher from '@/components/layout/LanguageSwitcher';
import ThemeToggle from '@/components/layout/ThemeToggle';
import { LabOSTopbar } from '@/lib/labos';

/** `/projects/:id/productions/:id` and the legacy `/production/:id`. */
const CONSOLE_ROUTE = /(^\/production\/)|(\/productions\/)/;

/**
 * App chrome: the LabOS strip, the Story Engine brand bar, and the project rail.
 *
 * The rail is hidden inside a production console. It lists PROJECTS, so while you're
 * watching a production it reads as a way to switch between runs — which it isn't;
 * clicking one leaves the console for a different project's page. The console also
 * needs the width: it is already three columns over a log panel, and it carries its
 * own "Back to project" link, so nothing is lost by dropping the rail.
 */
export default function AppShell({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  const inConsole = CONSOLE_ROUTE.test(pathname);

  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex h-screen flex-col">
        <LabOSTopbar
          appName="Story Engine"
          actions={
            <>
              <LanguageSwitcher />
              <ThemeToggle />
            </>
          }
        />
        <BrandBar />
        <div className="flex min-h-0 flex-1 border-t border-border">
          {!inConsole && <AppSidebar />}
          <main className="min-w-0 flex-1 overflow-y-auto">{children}</main>
        </div>
      </div>
    </TooltipProvider>
  );
}
